import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

// Text direction only (not an "enabled languages" list — those come from backend config).
const RTL_LANGS = new Set(["ar", "he", "fa", "ur"]);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("urlifa_lang") || "fr");

  const applyDir = useCallback((l) => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = l;
      document.documentElement.dir = RTL_LANGS.has(l) ? "rtl" : "ltr";
    }
  }, []);

  useEffect(() => { applyDir(lang); }, [lang, applyDir]);

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("urlifa_lang", l);
    applyDir(l);
  }, [applyDir]);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) {
      node = node?.[p];
      if (node === undefined) break;
    }
    if (node === undefined) {
      let fb = translations.fr;
      for (const p of parts) fb = fb?.[p];
      return fb ?? path;
    }
    return node;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
